import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';
import * as file from './../data/file';

/*_____________________
 *  IssueComment Data 
 *=====================
 */

/**
 * addIssueComment() create issue comment with add file is option
 * @param {object} props
 * @param {object} props.issue_id issue-id
 * @param {object} props.comment comment object
 * @param {string} props.logMode default: issueCommentCreate
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/Issue#insert-comment
 */
export function addIssueComment({
  issue_id,
  comment,
  logMode = 'issueCommentCreate',
}) {
  return httpClient
    .post(`${server.ISSUE_URL}/saveComment`, {
      issue: {
        id: issue_id,
      },
      comment,
      logMode,
    })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * updateIssueComment() update issue comment with add file is option by comment id
 * @param {object} props
 * @param {object} props.issue_id issue-id
 * @param {object} props.comment comment data object
 * @param {string} props.logMode default: issueCommentEdit
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/Issue#insert-comment
 */
export function updateIssueComment({
  issue_id,
  comment = {},
  logMode = 'issueCommentEdit',
}) {
  return httpClient
    .put(`${server.ISSUE_URL}/saveComment`, {
      issue: {
        id: issue_id,
      },
      comment,
      logMode,
    })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

// /**
//  * getList() get list issueComment v1
//  * @param {object} params
//  * @param {object} params.package base64 of props {lang, issue_id, orderByAcs = true }
//  * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/IssueComment
//  * @returns
//  */
// export function getList(params) {
//   return httpClient
//     .get(`${server.ISSUE_COMMEMNT_URL}/getList`, { params })
//     .then((result) => {
//       console.log('comment, ', result);
//       return result.data.content;
//     })
//     .catch((error) => {
//       throw error;
//     });
// }

/**
 * getListCore() get list issueComment
 * @param {object} params
 * @param {object} params.package base64 of props {lang, issue_id, orderByAcs = true }
 * @param {object} options
 * @param {object} options.includedThumbnail default: true
 * @returns
 */
async function getListCore(params, { includedThumbnail = true }) {
  try {
    let respComms = await httpClient.get(`${server.ISSUE_COMMEMNT_URL}/getList`, {
      params,
    });
    let comments = respComms.data.content;
    let customComments = [];
    if (includedThumbnail) {
      for (let comment of comments) {
        let issue_id = comment.IssueComments.issue_id;
        let files = comment.IssueComments.commentFiles
          ? comment.IssueComments.commentFiles.split(',')
          : [];
        let thumbnails = await file.thumbnails({ issue_id, files });
        comment.IssueComments.thumbnails = thumbnails;
        customComments.push(comment);
      }
    } else {
      customComments = comments;
    }
    return customComments;
  } catch (error) {
    throw error;
  }
}

/**
 * getList() get list issueComment v2
 * @param {object} params
 * @param {object} params.package base64 of props {lang, issue_id, orderByAcs = true }
 * @param {object} options
 * @param {object} options.includedThumbnail default: true
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/IssueComment
 * @returns
 */
export function getList(params, options = { includedThumbnail: true }) {
  return getListCore(params, options)
    .then((comments) => {
      return comments;
    })
    .catch((error) => {
      throw error;
    });
}
